import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/DespatchPostToPostSelectors';
// eslint-disable-next-line import/no-named-as-default
import Report from '../../../../common/components/Report';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function DespatchPostToPostPerformanceContainer(props) {
  return (
    <Report
      reportId={ReportDefinitions.POST_TO_POST_DESPATCH_PERFORMANCE.id}
      generatedOnDateTime={props.generatedDateTime}
      isLoading={props.isLoading}
      data={props.data}
      columns={props.columns}
      className="despatchPostToPostPerformanceReport"
    />
  );
}

function mapStateToProps(state, props) {
  return {
    data: getData(state, props),
    columns: getColumns(state, props),
    generatedDateTime: getGeneratedOnDateTime(state, props),
    isLoading: getIsLoading(state, props),
  };
}

DespatchPostToPostPerformanceContainer.propTypes = {
  generatedDateTime: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(DespatchPostToPostPerformanceContainer);
